import { base64ToArrayBuffer, KEY_SEPARATOR } from './crypto-utils';

export const extractNonceFromMessage = (
  defaultNonce: string,
  _message: string
) => {
  //@ts-ignore
  let nonce: ArrayBuffer = new TextEncoder().encode(defaultNonce);
  let encryptedMessage = _message;
  if (encryptedMessage.includes(KEY_SEPARATOR)) {
    const [_nonce, message] = encryptedMessage.split(KEY_SEPARATOR);
    encryptedMessage = message;
    nonce = base64ToArrayBuffer(_nonce);
  }
  return { nonce, encryptedMessage };
};
